import * as React from "react";
import GeneralSelect from "../../general_select";
import CreateService from "../../../service/create";
import PopDetail from "../../popdetail";
import {ProjectsService} from "../../../service/v1/projects";

export default class AddNewMonitoringProjectPane extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            project_type: {value: 0},
            description: '',
            projectOptions: {
                endpoint: `projects/project-types`,
                value: 'id',
                label: 'name',
                placeholder: 'Select Project'
            },
            is_m_n_e: 'none',
            is_not_m_n_e: 'none',
            is_new: 'none',
            is_village: 'none',
            is_ward: 'none',
            is_district: 'none',
            is_regional: 'none',
            is_zonal: 'none',
            is_village_multi: true,
            is_ward_multi: true,
            is_district_multi: true,
            is_regional_multi: true,
            is_zonal_multi: true,
            is_village_disabled: true,
            is_ward_disabled: true,
            is_district_disabled: true,
            is_regional_disabled: true,
            locality: '',
            project_list: {
                endpoint: 'projects/list',
                value: 'id',
                placeholder: 'Select Project',
                label: 'name'
            },
            zoneOptions: {endpoint: 'localities/list', value: 'id', label: 'name', placeholder: 'Select Zone'},
            regionOptions: {endpoint: 'localities/list', value: 'id', label: 'name', placeholder: 'Select Region'},
            districtOptions: {
                endpoint: 'localities/list',
                value: 'id',
                label: 'name',
                placeholder: 'Select District'
            },
            wardOptions: {
                endpoint: 'localities/list',
                value: 'id',
                label: 'name',
                placeholder: 'Select Ward'
            },
            villageOptions: {
                endpoint: `localities/list`,
                value: 'id',
                label: 'name',
                placeholder: 'Select Village'
            },
        }

        this.submit = this.submit.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
        this.generalSelect = this.generalSelect.bind(this)
    }

    handleChanges = (e) => {
        this.setState({[e.target.name]: e.target.value})
        //console.log(e.target.name)
    }

    generalSelect(data, name) {
        this.setState({
            [name]: data
        })
        console.log(data)
        console.log(this.state[name])
        let ids = []

        if (data.value === 0) {
            console.log('Zero')
            this.setState({
                is_new: 'table-row',
            })
        }

        switch (name) {
            case 'project_list':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                    this.setState({
                        villageOptions: {
                            endpoint: `projects/list`,
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Project'
                        }
                    })
                }
                break
            case 'project_type':
                if (data.label.toString().includes('Monitor')) {
                    this.setState({
                        locality: 'Monitoring',
                    })
                }
                if (data.label.toString().includes('Village') || data.label.toString().includes('CCRO')
                    || data.label.toString().toLowerCase().includes('formal')) {
                    this.setState({
                        is_village: 'table-row',
                        is_ward: 'table-row',
                        is_district: 'table-row',
                        is_ward_multi: false,
                        is_district_multi: false,
                        is_regional_multi: false,
                        is_regional: 'table-row',
                        is_zonal: 'none',
                        regionOptions: {
                            endpoint: `localities/list?level_id=` + sessionStorage.getItem('regional_level_id'),
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Region'
                        },
                        is_regional_disabled: false,
                        locality: 'Village'
                    })
                }
                if (data.label.toString().includes('District')) {
                    this.setState({
                        is_village: 'none',
                        is_ward: 'none',
                        is_district: 'table-row',
                        is_regional: 'table-row',
                        is_regional_multi: false,
                        is_zonal: 'none',
                        regionOptions: {
                            endpoint: `localities/list?level_id=` + sessionStorage.getItem('regional_level_id'),
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Region'
                        },
                        is_regional_disabled: false,
                        locality: 'District'
                    })
                }
                if (data.label.toString().includes('Region')) {
                    this.setState({
                        is_village: 'none',
                        is_ward: 'none',
                        is_district: 'none',
                        is_regional: 'table-row',
                        is_zonal: 'table-row',
                        is_zonal_multi: false,
                        locality: 'Regional'
                    })
                }
                if (data.label.toString().includes('Zon')) {
                    this.setState({
                        is_village: 'none',
                        is_ward: 'none',
                        is_district: 'none',
                        is_regional: 'none',
                        is_zonal: 'table-row',
                        locality: 'Zonal',
                        zoneOptions: {
                            endpoint: `localities/list?level_id=` + sessionStorage.getItem('zonal_level_id'),
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Zone'
                        },
                    })
                }
                if (data.label.toString().includes('Nation')) {
                    this.setState({
                        locality: 'National',
                    })
                }
                break
            case 'zone':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    is_regional_disabled: false,
                    regionOptions: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('regional_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select Region'
                    }
                })
                break;
            case 'region':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    is_district_disabled: false,
                    districtOptions: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('district_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select District'
                    }
                })
                break
            case 'district':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    is_ward_disabled: false,
                    wardOptions: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('ward_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select Ward'
                    }
                })
                break
            case 'ward':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    is_village_disabled: false,
                    villageOptions: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('village_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select Village'
                    }
                })
                break
        }
    }

    render() {

        return (<div className={'row'}>

            <div className={'col col-sm-12'} style={{padding: 0, height: '80vh'}}>

                <table style={{width: '94%', margin: '2%'}}>
                    <tbody>

                    <tr>
                        <td className={'label'} style={{width: '100%'}}>Project</td>
                    </tr>
                    <tr>
                        <td >
                            <GeneralSelect onChanges={(e) => this.generalSelect(e, 'project_list')}
                                           parameters={this.state.project_list}/>
                        </td>
                    </tr>

                    <tr style={{display: this.state.is_new}}>
                        <td className={'label'} style={{width: '100%'}}>Project Type</td>
                    </tr>
                    <tr style={{display: this.state.is_new}}>
                        <td>
                            <GeneralSelect onChanges={(e) => this.generalSelect(e, 'project_type')}
                                           parameters={this.state.projectOptions}/>
                        </td>
                    </tr>

                    <tr>
                        <td className={'label'} style={{width: '100%'}}>Project name</td>
                    </tr>
                    <tr>
                        <td>
                            <input type={'text'} style={{width: '99%', padding: '8px'}} name={'name'}
                                   onChange={this.handleChanges}/>
                        </td>
                    </tr>
                    <tr>
                        <td className={'label'}>Description</td>
                    </tr>
                    <tr>
                        <td>
                            <textarea rows={3} style={{width: '100%'}} name={'description'}
                                      onChange={this.handleChanges}/>
                        </td>
                    </tr>

                    <table style={{width: '100%'}}>
                        <tbody>
                        <tr style={{display: this.state.is_new}}>
                            <td className={'label'}>Registration Date</td>
                            <td className={'label'}>Authorization
                                Date
                            </td>
                        </tr>
                        <tr style={{display: this.state.is_new}}>
                            <td colSpan={1}>
                                <input type={'date'} style={{width: '90%', padding: '8px'}} name={'reg_date'}
                                       onChange={this.handleChanges}/>
                            </td>
                            <td colSpan={1}>
                                <input type={'date'} style={{width: '100%'}}
                                       name={'auth_date'} onChange={this.handleChanges}/>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <tr>
                        <td className={'label'}>Project Budget</td>
                    </tr>
                    <tr>
                        <td>
                            <input type={'number'} onChange={this.handleChanges}
                                   style={{width: '90%', padding: '10px'}} name={'budget'}/>
                        </td>
                    </tr>

                    <tr style={{display: this.state.is_zonal}}>
                        <td colSpan={2} className={'label'}>Zone</td>
                    </tr>
                    <tr style={{display: this.state.is_zonal}}>
                        <td colSpan={2}>
                            <GeneralSelect onChanges={(e) => this.generalSelect(e, 'zone')}
                                           parameters={this.state.zoneOptions}
                                           isMulti={this.state.is_zonal_multi}/>
                        </td>
                    </tr>
                    <tr style={{display: this.state.is_regional}}>
                        <td colSpan={2} className={'label'}>Regions</td>
                    </tr>
                    <tr style={{display: this.state.is_regional}}>
                        <td colSpan={2}>
                            <GeneralSelect onChanges={(e) => this.generalSelect(e, 'region')}
                                           parameters={this.state.regionOptions}
                                           isMulti={this.state.is_regional_multi}
                                           isDisable={this.state.is_regional_disabled}/>
                        </td>
                    </tr>
                    <tr style={{display: this.state.is_district}}>
                        <td colSpan={2} className={'label'}>District/Council</td>
                    </tr>
                    <tr style={{display: this.state.is_district}}>
                        <td colSpan={2}>
                            <GeneralSelect onChanges={(e) => this.generalSelect(e, 'district')}
                                           parameters={this.state.districtOptions}
                                           isMulti={this.state.is_district_multi}
                                           isDisable={this.state.is_district_disabled}/>
                        </td>
                    </tr>

                    <tr style={{display: this.state.is_ward}}>
                        <td colSpan={2} className={'label'}>Ward</td>
                    </tr>
                    <tr style={{display: this.state.is_ward}}>
                        <td colSpan={2}>
                            <GeneralSelect onChanges={(e) => this.generalSelect(e, 'ward')}
                                           parameters={this.state.wardOptions}
                                           isMulti={this.state.is_ward_multi}
                                           isDisable={this.state.is_ward_disabled}/>
                        </td>
                    </tr>

                    <tr style={{display: this.state.is_village}}>
                        <td colSpan={2} className={'label'}>Villages</td>
                    </tr>
                    <tr style={{display: this.state.is_village}}>
                        <td colSpan={2}>
                            <GeneralSelect onChanges={(e) => this.generalSelect(e, 'village')}
                                           parameters={this.state.villageOptions}
                                           isMulti={this.state.is_village_multi}
                                           isDisable={this.state.is_village_disabled}/>
                        </td>
                    </tr>

                    </tbody>
                </table>

                <div style={{textAlign: 'center', width: '100%', float: 'left'}}>
                    <button className={'btn submit'} onClick={this.submit}>
                        <span className={'fa fa-save'}/>Create Project
                    </button>
                </div>

            </div>

        </div>)
    }

    submit() {
        try {
            let name = this.state.name
            let desc = this.state.description
            let project_id = this.state.project_list.value
            let budget = this.state.budget

            let project_funder = []
            let locality = []

            ProjectsService.createProject({
                name: name,
                description: desc,
                locality_ids: locality,
                project: 'new',
                funder_ids: project_funder,
                budget: budget,
                reg_date: '',
                project_id: project_id
            }).then(r => {
                this.props.loadProjects()
                PopDetail.dismiss()
            })

        } catch (e) {
            alert(e)
        }
    }


}